document.addEventListener("DOMContentLoaded", () => {
	setTimeout(() => {
		if (frappe.session.user && frappe.session.user == 'Guest') {
			frappe.call({
				method: "wecom.api.get_wecom_config",
				args: {},
				callback: function (r) {
					if (r.message) {
						let login_debug = false;
						try {
							const params = new URLSearchParams(location.search || "");
							const v = String(params.get("login_debug") || "").toLowerCase();
							login_debug = v === "1" || v === "true" || v === "yes";
						} catch (e) {
							login_debug = false;
						}

						wecom.config = r.message;
						wecom.init_login(login_debug);
					}
				}
			})
		}
	}, 500)
})
